import Axios from "axios";
import { prefix } from "@/store/api";

const root = `${prefix}audit-log`;

const compactParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== null && value !== undefined && value !== "")
);

export const auditLogApi = {
  activities: (params = {}) => Axios.get(`${root}/activities`, { params: compactParams(params) }),
  activity: (uuid) => Axios.get(`${root}/activities/${encodeURIComponent(uuid)}`),
  meta: (params = {}) => Axios.get(`${root}/meta`, { params: compactParams(params) }),
  rawAudits: (params = {}) => Axios.get(`${root}/raw-audits`, { params: compactParams(params) }),
};

export default auditLogApi;
